// debugLog.js - Client-side debug logging utility
// Writes to the browser console only. The former server-side /api/debug-log
// endpoint was retired in favor of the activity log (api.track).
// Usage: import { debugLog } from '../utils/debugLog';
//        debugLog('label', { anyData: 'here' });

export const debugLog = (label, data) => {
  console.debug(`[DEBUG] ${label}`, data);
};
